export class Config {
  static TOKEN: string | null = null;

  static loadToken() {
    if (typeof window !== 'undefined') {
      const token = localStorage.getItem('token');
      if (token) Config.TOKEN = token;
    }
  }

  static saveToken(token: string) {
    Config.TOKEN = token;
    if (typeof window !== 'undefined') {
      localStorage.setItem('token', token);
    }
  }

  static clearToken() {
    Config.TOKEN = null;
    if (typeof window !== 'undefined') {
      localStorage.removeItem('token');
    }
  }
}
